import { Typography } from "@mui/material";
import { CreateDepartmentPayload } from "@rms-types/modules/department/dto";
import { Department } from "@rms-types/modules/department/entities/department";

import { schemas } from "@/components/form/constants";
import { FieldSchema } from "@/components";

export const ModifyDepartmentSchema: FieldSchema<CreateDepartmentPayload, Department>[] = [
  {
    type: "text",
    name: "name",
    label: "Name",
    required: true,
  },
  {
    type: "box",
    xs: 8,
  },
  {
    type: "box",
    children: (
      <>
        <Typography variant="overline">Members</Typography>
        <Typography>Select members to add to the department</Typography>
      </>
    ),
  },
  schemas.accountAsyncMultiSelect({
    name: "member_ids",
    xs: 12,
    getFilteredOptions: (data, values: CreateDepartmentPayload) =>
      data.filter(({ id }) => !values.member_ids?.includes(id)),
  }),
];
